import React, { useContext } from "react";
import { Context } from "../contexts/AppContext";
import { jsPDF } from "jspdf";

const CreditUsage = () => {
  const { value } = useContext(Context);
  const [appState] = value;
  const creditHistory = appState?.adminDetails?.creditHistory || [];

  // Sort latest first
  const history = [...creditHistory].reverse();

  // Calculate totals
  let totalUsed = 0;
  let totalPurchased = 0;

  history.forEach((entry) => {
    if (entry.type === "used") {
      totalUsed += entry.credits;
    } else if (entry.type === "purchased") {
      totalPurchased += entry.credits;
    }
  });

  const formatCredits = (credits, type) => {
    if (credits >= 1024) {
      const gb = credits / 1024;
      return `${type === "used" ? "-" : "+"} ${parseFloat(gb.toFixed(4))} GB`;
    } else {
      return `${type === "used" ? "-" : "+"} ${parseFloat(
        credits.toFixed(4)
      )} MB`;
    }
  };

  const remainingCredits = (totalPurchased - totalUsed) / 1024;

  // ========== ⭐ PREMIUM INVOICE GENERATOR ⭐ ==========
const generateInvoicePDF = async (entry) => {
  const doc = new jsPDF("p", "mm", "a4");

  // ========= LOAD LOGO =========
  const logo = await fetch("/img/logo-invoice.png")
    .then((res) => res.blob())
    .then(
      (blob) =>
        new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsDataURL(blob);
        })
    );

      // ========= LIGHT BACKGROUND =========
  doc.setFillColor("#EAF2EF");
  doc.rect(0, 0, 210, 297, "F");

  // ========= WHITE INVOICE CONTAINER =========
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(5, 5, 200, 287, 3, 3, "DF");

  // ========= WATERMARK (MODERN LIGHT) =========
  doc.setTextColor(230);
  doc.setFontSize(70);
  doc.setFont("helvetica", "bold");
  doc.text("VIDMANTRA", 40, 260, { angle: 35, opacity: 0.06 });

  // ========= INVOICE ID DATE =========
  const d = new Date(entry.date);
  const invoiceIdDate =
    d.getDate().toString().padStart(2, "0") +
    (d.getMonth() + 1).toString().padStart(2, "0") +
    d.getFullYear();

  // ========= HEADER =========
  if (logo) doc.addImage(logo, "PNG", 15, 10, 30, 30);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(26);
  doc.setTextColor(30);
  doc.text("INVOICE", 105, 20, { align: "center" });

  doc.setFont("helvetica", "normal");
  doc.setFontSize(12);
  doc.setTextColor(70);
  doc.text(`Invoice ID: VF${invoiceIdDate}`, 150, 14);
  doc.text(`Date: ${d.toLocaleDateString("en-GB")}`, 150, 21);

  // ========= SECTION BOX STYLES =========
  const sectionBox = (x, y, w, h) => {
    doc.setFillColor(248, 248, 248);
    doc.setDrawColor(220, 220, 220);
    doc.roundedRect(x, y, w, h, 2, 2, "FD");
  };

  // ========= COMPANY DETAILS BOX =========
  sectionBox(15, 40, 85, 45);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(30);
  doc.text("Company", 20, 48);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(80);
  doc.text("VidMantra", 20, 60);
  doc.text("Wolverhampton", 20, 67);
  doc.text("Barkely Close WL36 2JT, UK", 20, 74);
  doc.text("support@vidmantra.com", 20, 81);

  // ========= CUSTOMER DETAILS BOX =========
  sectionBox(110, 40, 85, 45);

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(30);
  doc.text("Bill To", 115, 48);

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(80);
  doc.text(`Name: ${appState?.adminDetails?.companyName || "Admin"}`, 115, 60);
  doc.text(`Email: ${appState?.adminDetails?.email || "-"}`, 115, 67);
  doc.text(`Role: ${appState?.adminDetails?.role || "-"}`, 115, 74);

  // ========= TABLE HEADER =========
  const tableTop = 100;

  doc.setFillColor(240, 240, 240);
  doc.roundedRect(15, tableTop, 180, 12, 2, 2, "F");

  doc.setTextColor(40);
  doc.setFont("helvetica", "bold");
  doc.setFontSize(12);

  doc.text("Description", 20, tableTop + 8);
  doc.text("Credits", 105, tableTop + 8);
  doc.text("Amount ($)", 165, tableTop + 8);

  // ========= TABLE ROW =========
  doc.setFillColor(255, 255, 255);
  doc.roundedRect(15, tableTop + 12, 180, 14, 2, 2, "F");

  doc.setFont("helvetica", "normal");
  doc.setFontSize(11);
  doc.setTextColor(60);

  doc.text(entry.purpose ?? "Credit Purchase", 20, tableTop + 22);
  doc.text(`${(entry.credits / (1024 * 5)).toFixed(2)}`, 105, tableTop + 22);
  doc.text(`$${(entry.price / 100).toFixed(2)}`, 165, tableTop + 22);

  // ========= TOTAL BOX (MODERN BLUE STRIP) =========
  const totalY = tableTop + 40;

  doc.setFillColor(248, 248, 248);
  doc.setDrawColor(210, 210, 210);
  doc.roundedRect(15, totalY, 180, 18, 2, 2, "FD");

  doc.setFont("helvetica", "bold");
  doc.setFontSize(13);
  doc.setTextColor(30);
  doc.text("Total", 20, totalY + 12);

  doc.setTextColor(0, 90, 180);
  doc.text(`$${(entry.price / 100).toFixed(2)}`, 190 - 5, totalY + 12, {
    align: "right",
  });

  // ========= FOOTER =========
  doc.setFontSize(10);
  doc.setTextColor(120);
  doc.text(
    "This is a system-generated invoice. No signature required.",
    105,
    278,
    { align: "center" }
  );

  doc.setTextColor(70);
  
  doc.text("Thank you for choosing VidMantra!", 105, 285, { align: "center" });
 doc.text("Where Memories Live!", 105, 285, { align: "center" });
  doc.save(`invoice-${entry.invoiceId || entry.date}.pdf`);
};



  return (
    <div className="p-4 bg-white rounded-2xl shadow-md w-full text-center">
      <h2 className="text-xl font-semibold mb-4">Data  Usage History</h2>

      {creditHistory.length === 0 ? (
        <p className="text-gray-500">No credit history found.</p>
      ) : (
        <div className="overflow-x-auto">
          <table class="table-wrapper" className="min-w-full border border-gray-200 text-sm">
            <thead className="bg-gray-100">
              <tr>
                <th className="text-center p-2 border-b">Date</th>
                <th className="text-center p-2 border-b">Description</th>
                <th className="text-center p-2 border-b">Credits</th>
                <th className="text-center p-2 border-b">Invoice</th>
              </tr>
            </thead>

            <tbody className="font-bold">
              {history.map((entry, index) => (
                <tr key={index} className="hover:bg-gray-50">
                  <td className="p-2 border-b">
                    {new Date(entry.date).toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </td>

                  <td className="p-2 border-b">
                    {entry.purpose ||
                      (entry.type === "used" ? "Used" : "Purchased")}
                  </td>

                  <td
                    className={`p-2 border-b font-medium ${
                      entry.type === "used"
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {formatCredits(entry.credits, entry.type)}
                  </td>

                  {/* ⭐ Invoice Button only for PURCHASE entries */}
                  <td className="p-2 border-b text-center">
                    {entry.type === "purchased" ? (
                      <button
                        onClick={() => generateInvoicePDF(entry)}
                        className="px-3 py-1 bg-gray-600 text-white rounded-md hover:bg-gray-700"
                      >
                        Invoice
                      </button>
                    ) : (
                      "-"
                    )}
                  </td>
                </tr>
              ))}

              <tr className="bg-gray-800 text-white">
                <td className="p-2 font-semibold text-center" colSpan={1}>
                  Remaining Credits
                </td>
                <td className="p-2 font-semibold text-center" colSpan={1}></td>
                <td className="p-2 font-semibold text-center text-blue-600">
                  {parseFloat(remainingCredits.toFixed(3))} GB
                </td>
                <td className="p-2 font-semibold text-center" colSpan={1}></td>
              </tr>
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default CreditUsage;
